<template>
  <div class="catalogTip">
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" append-to-body center class="catalog-tip-dialog">
      <span>{{ tipText }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleClickUpdate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'catalogtip',
  data() {
    return {
      dialogVisible: false
    }
  },
  props: {
    tipText: String
  },
  methods: {
    handleClickUpdate() {
      this.$emit('tipSure')
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss">
.catalog-tip-dialog {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
  &:after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    height: 100%;
  }
  .el-dialog {
    margin: 30px auto !important;
    display: inline-block;
    vertical-align: middle;
    text-align: center;
    white-space: normal;
  }
}
</style>
